import * as React from "react";
import { stylesheet } from "typestyle";
import { CloseIcon } from "./CloseIcon.js";
export function CloseButton({ label, onClick }) {
    return (React.createElement("div", { className: styles.closeButton, onClick: onClick },
        label,
        React.createElement(CloseIcon, { className: styles.closeIcon })));
}
const styles = stylesheet({
    closeIcon: {
        marginLeft: "0.5rem",
        fontSize: "1.5rem",
    },
    closeButton: {
        fontSize: "1.25em",
        textTransform: "uppercase",
        display: "flex",
        alignItems: "center",
        backgroundColor: "var(--color-primary)",
        color: "#fff",
        marginLeft: "0.25rem",
        padding: "0.25rem 1.5rem",
    },
});
//# sourceMappingURL=CloseButton.js.map